<template>
  <div id="main">
    <section id="content">
      <div class="container">
        <h1>Descargar archivos</h1>
        <div class="row">
          <div class="col s12 m8">
            <p>
              Total de Archivos:
              <strong>{{ files.length }}</strong>
            </p>
          </div>
          <div class="col s12 m4 right">
            <input
              type="text"
              class="search"
              placeholder="Buscar archivo..."
              v-model="fileToSearch"
              @keyup.enter="searchFiles()"
            />
          </div>
        </div>
        <table class="striped responsive-table">
          <thead>
            <tr>
              <td>Nombre</td>
              <td>Clasificación</td>
              <td>Tamaño</td>
              <td>Hash</td>
              <td></td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="file in searchFiles" :key="file.id">
              <td>
                <a class="adjunto">
                  <i class="material-icons left">insert_drive_file</i>
                  {{ file.name }}
                </a>
              </td>
              <td>{{ file.type }}</td>
              <td>{{ file.size }}</td>
              <td>
                <samp
                  class="tooltipped"
                  data-position="top"
                  data-tooltip="Hacer click para copiar el código completo"
                  v-clipboard:copy="file.hash"
                  v-clipboard:success="hashCopied"
                  >{{ file.hash }}</samp
                >
              </td>
              <td>
                <label>
                  <input type="checkbox" @click="markFilesToDownload(file)" />
                  <span></span>
                </label>
              </td>
              <td>
                <label
                  @click="deleteFile(file)"
                  class="icon delete tooltipped"
                  data-position="left"
                  data-tooltip="Eliminar archivo"
                >
                  <i class="material-icons">delete</i>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="input-field col right">
            <button
              @click="downloadFiles()"
              class="btn waves-effect waves-light"
            >
              <i class="material-icons left">file_download</i> Descargar
              archivos
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { helpersMixin } from "../mixins/helpers";

export default {
  name: "descargar",
  data() {
    return {
      filesToDownload: [],
      fileToSearch: "",
      file: "",
      files: [],
      checkedFile: [],
    };
  },
  mounted() {
    this.getFilesToDownload();
  },
  computed: {
    searchFiles() {
      return this.files.filter((file) => {
        return file.name
          .toLowerCase()
          .includes(this.fileToSearch.toLowerCase());
      });
    },
  },
  methods: {
    getFilesToDownload() {
      let loader = this.$loading.show({
        container: this.fullPage,
        canCancel: false
      });      
      this.$store.dispatch("getFilesToDownload").then((response) => {
        loader.hide();
        response.data.files.forEach((file) => {
          this.file = {
            name: file.name,
            hash: file.hash,
            type: file.type,
            size: helpersMixin.methods.formatBytes(file.size),
          };
          this.files.push(this.file);
        });
      });
    },
    markFilesToDownload(file) {
      if (this.filesToDownload.includes(file)) {
        this.filesToDownload.splice(this.filesToDownload.indexOf(file), 1);
      } else {
        this.filesToDownload.push(file);
      }
    },
    downloadFiles() {
      if (this.filesToDownload.length) {
        this.filesToDownload.forEach((file, index) => {
          if (file == null) {
            this.filesToDownload.splice(index, 1);
          }
        });
        this.$store
          .dispatch("downloadFiles", {
            files: this.filesToDownload,
          })
          .then((response) => {
            let fileURL = window.URL.createObjectURL(
              new Blob([response.data]),
              { type: "application/pdf" }
            );
            let fileLink = document.createElement("a");
            let fileName =
              "download" + (this.filesToDownload.length > 1 ? ".zip" : ".pdf");
            if (response.headers["Content-Disposition"]) {
              fileName = response.headers["Content-Disposition"]
                .split("=")[1]
                .replace(/^\\"+|\\"+$/g, "");
            }
            fileLink.href = fileURL;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
            this.$fire({
              title: "Descargado!",
              text: "Archivos descargados correctamente",
              type: "success",
              showConfirmButton: true,
            }).then((r) => {
              if (r.value) {
                window.location.reload();
              }
            });
          });
      } else {
        this.$fire({
          title: "Debe seleccionar al menos un archivo para descargar",
          type: "error",
        });
      }
    },
    deleteFile(file) {
      this.$fire({
        title: "¿Está seguro que desea eliminar el archivo?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si, eliminar",
      }).then((res) => {
        if (res.value) {
          if (this.files.includes(file)) {
            this.files.splice(this.files.indexOf(file), 1);
          }
          this.$store
            .dispatch("deleteFile", {
              file: file,
              signed: true,
            })
            .then((response) => {
              if (response.data && response.data.status) {
                this.$fire({
                  title: "¡Archivo eliminado correctamente!",
                  type: "success",
                });
              }
            });
        }
      });
    },
    hashCopied() {
      this.$fire({
        title: "Hash Copiado!",
        text: "Hash de archivo copiado correctamente",
        type: "success",
        showConfirmButton: true,
      });
    },
  },
};
</script>